<template>
  <section id="SliderQuiz">
    <transition
      name="fade"
      mode="out-in"
    >
      <div v-if="step === 1 || step === 2">
        <h5>Question 1/2</h5>
        <h3>How many calls do you think were made by just one telecom in India?</h3>
        <div class="range">
          <input
            class="range__input"
            type="range"
            step="50"
            v-model="rangeQ1"
            :data-value="rangeQ1"
            :disabled="answers[0]"
          >
          <div
            class="range__thumb"
            v-if="!answers.length"
          ></div>
          <div
            v-if="answers.length"
            class="correct-range__thumb right"
          ></div>
          <div
            v-if="answers.length && answers[0] !== '100'"
            class="wrong-range__thumb"
            :class="{left: answers[0] === 0, mid: answers[0] === '50'}"
          ></div>
          <div class="range__track">
            <div class="range__steps">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <ul class="range__labels">
            <li>127,000,000</li>
            <li>181,000,000</li>
            <li>277,000,000</li>
          </ul>
        </div>
        <button
          class="button"
          @click="answerQ1"
        >Continue</button>
        <button
          class="button button--plain"
          @click="revealAnswer"
        >No thanks, just show me the answers</button>
      </div>
      <div v-else-if="step === 3 || step === 4">
        <h5>Question 2/2</h5>
        <h3>How many calls do you think were made by just one e-commerce company in the UK?</h3>
        <div class="range">
          <input
            class="range__input"
            type="range"
            step="50"
            v-model="rangeQ2"
            :data-value="rangeQ2"
          >
          <div
            class="range__thumb"
            v-if="answers.length === 1"
          ></div>
          <div
            v-if="answers.length === 2"
            class="correct-range__thumb mid"
          ></div>
          <div
            v-if="answers.length === 2 && answers[1] !== '50'"
            class="wrong-range__thumb"
            :class="{left: answers[1] === 0, right: answers[1] === '100'}"
          ></div>
          <div class="range__track">
            <div class="range__steps">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <ul class="range__labels">
            <li>11,500,000</li>
            <li>20,000,000</li>
            <li>24,000,000</li>
          </ul>
        </div>
        <button
          class="button"
          @click="answerQ2"
        >Continue</button>
      </div>
      <div v-else>
        <ul class="stats">
          <li class="stat">
            <div class="stat__text">277,000,000 calls by just one telecom in India</div>
          </li>
          <li class="stat">
            <div class="stat__text">20,000,000 calls made from an e-commerce company in the UK.</div>
          </li>
        </ul>
      </div>
    </transition>
    <QuizModal
      :title="quizModalTitle"
      :show="showQuizModal"
      :fb="fb"
      :tw="tw"
      :wa="wa"
      @close="showQuizModal = false"
    />
  </section>
</template>

<script>
import { ref } from "vue";
import QuizModal from "@/components/QuizModal";
import { useGtag } from "vue-gtag-next";
import sharing from "@/share";

export default {
  components: {
    QuizModal,
  },
  setup() {
    const { event } = useGtag();
    const step = ref(1);
    const rangeQ1 = ref("0");
    const rangeQ2 = ref("0");
    const answers = ref([]);
    const showQuizModal = ref(false);
    const quizModalTitle = ref(null);

    const fb = ref(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        sharing.sliderQuiz.url
      )}`
    );
    const tw = ref(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        sharing.sliderQuiz.tw + " " + sharing.sliderQuiz.url
      )}`
    );
    const wa = ref(
      `whatsapp://send?text=${encodeURIComponent(
        sharing.sliderQuiz.wa + " " + sharing.sliderQuiz.url
      )}`
    );

    function answerQ1() {
      answers.value[0] = rangeQ1.value;
      step.value++;
    }
    function answerQ2() {
      answers.value[1] = rangeQ2.value;
      step.value++;
      let numberOfCorrectAnswers = 0;
      if (rangeQ1.value === "100") numberOfCorrectAnswers++;
      if (rangeQ2.value === "50") numberOfCorrectAnswers++;
      quizModalTitle.value = `${numberOfCorrectAnswers} out of 2!`;
      showQuizModal.value = true;
      event("completed_slider_quiz", {
        event_category: "quiz",
        event_label: "slider_quiz",
      });
    }
    function revealAnswer() {
      step.value = 5;
      event("skipped_slider_quiz", {
        event_category: "quiz",
        event_label: "slider_quiz",
      });
    }
    return {
      step,
      answers,
      rangeQ1,
      rangeQ2,
      answerQ1,
      answerQ2,
      revealAnswer,
      showQuizModal,
      quizModalTitle,
      fb,
      tw,
      wa,
    };
  },
};
</script>

<style scoped>
#SliderQuiz {
  background-color: var(--dark-blue);
  background-image: url("../assets/images/bg-pattern.png");
  background-position: center center;
  background-size: cover;
  padding: 48px 20px;
  position: relative;
}
#SliderQuiz > div {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
}
#SliderQuiz h5 {
  font-size: 20px;
  line-height: 24px;
  opacity: 0.6;
  margin-bottom: 32px;
}
#SliderQuiz h3 {
  font-size: 24px;
  line-height: 29px;
  margin-bottom: 24px;
}
input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
}
input[type="range"]:focus {
  outline: none;
}
input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 20px;
  background: transparent;
  cursor: pointer;
}
input[type="range"]::-webkit-slider-thumb {
  height: 76px;
  width: 76px;
  margin-top: -28px;
  border-radius: 100%;
  cursor: pointer;
  -webkit-appearance: none;
}
input[type="range"]:focus::-webkit-slider-runnable-track {
  background: transparent;
}
input[type="range"]::-moz-range-track {
  width: 100%;
  height: 20px;
  cursor: pointer;
  background: transparent;
}
input[type="range"]::-moz-range-thumb {
  height: 76px;
  width: 76px;
  border-radius: 100%;
  background: transparent;
  cursor: pointer;
}
input[type="range"]::-ms-track {
  width: 100%;
  height: 20px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}

input[type="range"]::-ms-fill-lower {
  background: transparent;
}
input[type="range"]::-ms-fill-upper {
  background: transparent;
}
input[type="range"]::-ms-thumb {
  height: 76px;
  width: 76px;
  border-radius: 100%;
  background: transparent;
  cursor: pointer;
}
input[type="range"]:focus::-ms-fill-lower {
  background: transparent;
}
input[type="range"]:focus::-ms-fill-upper {
  background: transparent;
}

.range {
  margin-top: 48px;
  width: 100%;
  max-width: 700px;
  position: relative;
  padding-top: 56px;
  display: flex;
  justify-content: center;
}

.range__input {
  width: 100%;
  position: absolute;
  top: -20px;
  left: 0;
  height: 40px;
  appearance: none;
  background: transparent;
}

.correct-range__thumb,
.wrong-range__thumb,
.range__thumb {
  position: absolute;
  width: 76px;
  height: 76px;
  border-radius: 100%;
  top: -38px;
  z-index: 1;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position: center center;
  pointer-events: none;
}

.range__input[data-value="0"] + .range__thumb {
  background-image: url("../assets/emojis/stage-1.svg");
  left: 0;
}

.range__input[data-value="50"] + .range__thumb {
  background-image: url("../assets/emojis/stage-2.svg");
  left: 50%;
  margin-left: -38px;
}

.range__input[data-value="100"] + .range__thumb {
  background-image: url("../assets/emojis/stage-3.svg");
  right: 0;
}

.wrong-range__thumb {
  z-index: 2;
  background-image: url("../assets/icons/cross-icon.svg") !important;
  transform: scale(0.75, 0.75) !important;
}

.correct-range__thumb {
  z-index: 2;
  background-image: url("../assets/icons/tick-icon.svg") !important;
}

.left {
  left: 0;
}
.mid {
  left: 50%;
  margin-left: -38px;
}
.right {
  right: 0;
}

.range__track {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  height: 8px;
  width: calc(100% - 76px);
  left: 38px;
  background-color: #fff;
}

.range__steps {
  pointer-events: none;
  margin-left: -4px;
  margin-right: -4px;
  width: calc(100% + 8px);
  display: flex;
  justify-content: space-between;
}

.range__steps > div {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: var(--dark-blue);
  border: 6px solid white;
}

.range__labels {
  display: flex;
  width: 100%;
  justify-content: space-between;
  list-style: none;
  font-weight: 700;
  font-size: 12px;
  font-family: "Montserrat", sans-serif;
}

@media screen and (min-width: 720px) {
  #SliderQuiz h3 {
    font-size: 56px;
    line-height: 68px;
    margin-bottom: 48px;
  }
  .range {
    margin-bottom: 32px;
  }
  .range__labels {
    font-size: 24px;
    line-height: 29px;
  }
}
</style>